import React, { useState, useEffect } from 'react';
import { Button, Checkbox, FormControlLabel, Grid, MenuItem, Modal, Select } from '@material-ui/core';
import placeHolderProdImage from '../../prod.png';
import { SERVER_URL } from '../../utils';
import ImageModel from './ImageModel';
import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

const Products = (props) => {
  console.log("MOBILE", props.isMobile);
  return (
    props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />
  )
}
  
export default Products;